import React,{useState} from 'react'
import { useNavigate } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import BackgroundImage from '../../../images/public/02.jpg'
import Publicinput from '../../../components/forms/publicinput'
import Publicbutton from '../../../components/forms/publicbutton'
import Facebook from '../login/facebook'
import Google from '../login/google'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import SignupFunctions from '../../../functions/public/signup'
import Publicbuttonalt from '../../../components/forms/publicbuttonalt';

const Mobile = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(0)
    const [firstname, setFirstname] = useState('')
    const [lastname, setLastname] = useState('')
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [passShow, setPassShow] = useState(false);
    const [contact, setContact] = useState('')
    const [contactveifyinprocess, setContactveifyinprocess] = useState(false);
    const [opt, setOtp] = useState('');
  return (
    <div className='v2_public_signup_mobile_wrapper' style={{backgroundImage:`url(${BackgroundImage})`}}>
      <div className='v2_public_signup_mobile_overlay'>
        <div className='v2_public_signup_mobile_container'>
            <div className='v2_public_signup_mobile_header'>
                <div className='v2_public_signup_mobile_header_backbutton'>
                    <Link to={page === 0? '/login' : '#'}>
                        <FontAwesomeIcon onClick={
                            ()=>{
                                if(page!== 0){
                                    setPage(page -1);
                                }
                            }
                        } icon={faChevronLeft}/>
                    </Link>
                </div>
                <div className='v2_public_signup_mobile_header_title'>
                    <h3>
                        {page === 0 &&
                            <>Sign up</>
                        }
                        {page === 1 &&
                            <>Your phone!</>
                        }
                        {page === 2 &&
                            <>OTP Verification</>
                        }
                    </h3>
                </div>
            </div>
            <div className='v2_public_signup_mobile_form_container'>
                {page === 0 &&
                    <>
                    <div className='v2_public_signup_mobile_form_row'>
                        <div className='v2_public_signup_mobile_form_col50'>
                            <Publicinput Lable={'First name'} Placeholder={'Enter first name'} Type={'text'} Value={firstname} setValue={setFirstname}/>
                        </div>
                        <div className='v2_public_signup_mobile_form_col50'>
                            <Publicinput Lable={'Last name'} Placeholder={'Enter last name'} Type={'text'} Value={lastname} setValue={setLastname}/>
                        </div>
                    </div>
                    <Publicinput Lable={'Email'} Placeholder={'Enter email'} Type={'text'} Value={email} setValue={setEmail}/>
                    <Publicinput Lable={'Username'} Placeholder={'Enter username'} Type={'text'} Value={username} setValue={setUsername}/>
                    <Publicinput Lable={'Password'} Placeholder={'Enter password'} Type={passShow ? 'text' : 'password'} Value={password} setValue={setPassword} Icon={passShow ? <FontAwesomeIcon onClick={()=>{setPassShow(!passShow)}} icon={faEye}/> : <FontAwesomeIcon onClick={()=>{setPassShow(!passShow)}} icon={faEyeSlash}/>}/>
                    <Publicbutton Value={'Next'} Action={()=>{
                        if(firstname === "" || lastname === "" || email === "" || username === "" || password === ""){
                            alert("Fields Empty");
                            return;
                        }
                        setPage(1);
                    }}/>
                    <div className='v2_public_signup_mobile_form_or'>
                        <p>or</p>
                    </div>
                    <div className='v2_public_signup_mobile_form_social'>
                        <Facebook/>
                        <Google/>
                    </div>
                    </>
                }
                {page === 1 &&
                    <>
                    <Publicinput Lable={'Phone number'} Placeholder={'Enter phone number'} Type={'text'} Value={contact} setValue={setContact}/>
                    <p className='v2_public_signup_mobile_form_details'>A 5 digit OTP will be sent via SMS to verify your phone number</p>
                    <Publicbutton Value={contactveifyinprocess? 'Please wait...':'Verify'} Action={()=>{
                        if(contactveifyinprocess){
                            return;
                        }
                        if(contact === ""){
                            alert("Fields Empty");
                            return;
                        }
                        setContactveifyinprocess(true)
                        SignupFunctions.CodeSend(contact,(success)=>{
                            if(success){
                                setContactveifyinprocess(false)
                                setPage(2);
                            }
                            else{
                                setContactveifyinprocess(false)
                            }
                        })
                    }}/>
                    <div className='v2_public_signup_mobile_form_or'>
                        <p>or</p>
                    </div>
                    <Publicbuttonalt Value={'Verify later'} Action={()=>{
                        SignupFunctions.SubmitRegistration({
                            username : username,
                            password : password,
                            email : email,
                            role : 'individual',
                            firstname : firstname,
                            lastname : lastname,
                            location : 1,
                            contact : "",
                            address : "",
                            cnic : "",
                            getupdates : 1,
                            intrusts : [],
                            phoneverified: 0
                        },(success)=>{
                            if(success){
                                navigate('/login');
                            }
                        });
                    }}/>
                    <div className='v2_public_signup_mobile_form_signin'>
                        <p>Have an account? <Link to={'/login'}>Login</Link></p>
                    </div>
                    </>
                }
                {page === 2 &&
                    <>
                    <Publicinput Lable={'OTP'} Placeholder={'Enter OTP'} Type={'number'} Value={opt} setValue={setOtp}/>
                    <Publicbutton Value={'Sign up'} Action={()=>{
                        if(contact === "" || opt === ""){
                            alert("Fields Empty");
                            return;
                        }
                        SignupFunctions.VerifyCode((contact,opt,(success)=>{
                            if(success){
                                SignupFunctions.SubmitRegistration({
                                    username : username,
                                    password : password,
                                    email : email,
                                    role : 'individual',
                                    firstname : firstname,
                                    lastname : lastname,
                                    location : 1,
                                    contact : contact,
                                    address : "",
                                    cnic : "",
                                    getupdates : 1,
                                    intrusts : [],
                                    phoneverified: 1
                                },(success2)=>{
                                    if(success2){
                                        navigate('/login');
                                    }
                                });
                            }
                        }))
                    }}/>
                    <div className='v2_public_signup_mobile_form_signin'>
                        <p>Have an account? <Link to={'/login'}>Login</Link></p>
                    </div>
                    </>
                }
            </div>
        </div>
      </div>
    </div>
  )
}

export default Mobile
